module.exports = __webpack_public_path__ + "img/1.19dcb6aa.jpg";